import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../../app/stores/store";
import agent from "../../../app/api/agent";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { array } from "yup/lib/locale";
import { Button, Icon } from "semantic-ui-react";
import { Grid } from "semantic-ui-react";
import Formm from "../../FormulariosCC/create/Form";
import CCTiposDeCuentasList from "./CCTiposDeCuentasList";

export default observer(function CCTiposDeCuentas() {
  const { CCTiposDeCuentasStore, modalStore } = useStore();
  const { loadCCTiposDeCuentas, CCTipoDeCuentaRegistry } =
    CCTiposDeCuentasStore;

  useEffect(() => {
    if (CCTipoDeCuentaRegistry.size <= 1) {
      loadCCTiposDeCuentas();
    }
  }, [CCTipoDeCuentaRegistry.size, loadCCTiposDeCuentas]);

  if (CCTiposDeCuentasStore.loadingInitial)
    return <LoadingComponent content="Cargando datos.." />;

  return (
    <>
      <h1>Tipos de Cuentas</h1>
      <div className="buscar"> </div>
      <Button
        floated="right"
        positive
        size="small"
        className="cueboton"
        onClick={() => modalStore.openModal(<Formm />, 'mini')}
      >
        {/* <Icon name='add' /> */}
        Crear
      </Button>
      <CCTiposDeCuentasList />
    </>
  );
});
